import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.admin').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.admin', {
                abstract: true,
                component: 'contentLayout',
                data: {
                    authorizedRole: 'OPERATION'
                }
            })
            .state('app.admin.metrics', {
                url: '/admin/metrics/{application}',
                views: {
                    content: {
                        component: 'metrics'
                    }
                },
                resolve: {
                    application: [
                        '$transition$',
                        function($transition$) {
                            return $transition$.params().application;
                        }
                    ]
                }
            })
            .state('app.admin.monitoring', {
                url: '/admin/monitoring/{application}',
                views: {
                    content: {
                        component: 'monitoring'
                    }
                },
                resolve: {
                    application: [
                        '$transition$',
                        function($transition$) {
                            return $transition$.params().application;
                        }
                    ]
                }
            })
            .state('app.admin.periodictasks', {
                url: '/admin/periodictasks',
                views: {
                    content: {
                        component: 'periodictasks'
                    }
                }
            })
            .state('app.admin.audit', {
                url: '/admin/audit/{application}',
                views: {
                    content: {
                        component: 'audit'
                    }
                },
                resolve: {
                    application: [
                        '$transition$',
                        function($transition$) {
                            return $transition$.params().application;
                        }
                    ]
                }
            })
    }
})();
